import {
  // getCurrentInstance,
  ref,
  computed,
  nextTick,
} from 'vue'
import * as _ from 'lodash-es'
import { get, post, setValueByPath } from '../../../utils/index'
import { pgMessage } from '../../message/index'
export default function useInputCellEdit({ data, props }) {
  // const { proxy } = getCurrentInstance()
  const inputRef = ref(null)
  const isEdit = ref(false)

  const isDisabled = computed(() => data.value == undefined || data.value === '')

  // 获取 formData
  const getFormData = async () => {
    if (props.formDataUrl) {
      const [res] = await get(props.formDataUrl, props.formDataParam)
      if (res.code !== 200) {
        console.error('获取表单数据(formData)失败')
      } else {
        return res.data
      }
    }

    return
  }
  // 生成新的 formData
  const updateFormData = (formData) => {
    if (!formData) return

    const val = !_.isNil(data.value) && !_.isEmpty(data.value) ? data.value : null

    if (props.valueToSaveUrlParamKey) {
      setValueByPath(formData, props.valueToSaveUrlParamKey, val)
    } else {
      setValueByPath(formData, props.conCode, val)
    }

    return formData
  }
  // 查找指定的 parent 组件
  const searchParent = (el) => {
    if (!props.targetComponent) return

    if (el) {
      if (el.$options.name === props.targetComponent) {
        return el
      } else {
        return searchParent(el.$parent)
      }
    }

    return
  }

  // 切换编辑状态
  const switchEdit = () => {
    if (!isEdit.value) {
      isEdit.value = true
      nextTick(() => {
        inputRef.value?.focus()
      })
    }
  }

  // 修改当前行单元格的值
  const changeCellValue = (column, val, row, isDel = false) => {
    console.log('changeCellValue row: ', row)
    if (props.reload && props.row) {
      if (!props.row?.id) props.row.id = row?.id
      props.row[column] = isDel ? null : val // 更新单元格值
    }
  }

  // 输入
  const onInput = (val) => {
    console.log('输入: ', val)
    if (props.value !== val) {
      data.value = val
    }
  }
  // 取消
  const onCancel = (isAllCear = false) => {
    console.log('取消')
    isEdit.value = false

    if (isAllCear) data.value = props.value
  }
  // 删除
  const onDelete = async () => {
    console.log('删除', data.value, typeof data.value)
    if (props.delUrl) {
      const newParams = _.merge({ ids: props.row.id }, props.delUrlParams)
      const [res] = await post(props.delUrl, newParams)

      if (res.code === 200) {
        pgMessage({
          type: 'success',
          message: '删除成功',
        })

        // 更新单元格的值
        changeCellValue(props.conCode, data.value, null, true)

        onCancel()
      } else {
        onCancel(true)
      }
    } else {
      console.error('缺少 delUrl 参数！')
    }
  }
  // 保存
  const onSave = async () => {
    console.log('保存', data.value)
    if (data.value == null) {
      onCancel(true)
      return
    }
    if (props.saveUrl) {
      const formData = await getFormData()
      const newFormData = updateFormData(formData)

      if (!newFormData) return

      const newParams = _.merge(newFormData, props.saveUrlParams)
      const [res] = await post(props.saveUrl, newParams)

      if (res.code === 200) {
        pgMessage({
          type: 'success',
          message: '保存成功',
        })

        // 更新单元格的值
        changeCellValue(props.conCode, data.value, res.data)

        // const $parent = searchParent(proxy.$parent) // 查找指定的父组件
        // if (props.reload) $parent?.reload() // 刷新

        onCancel()
      } else {
        onCancel(true)
      }
    } else {
      console.error('缺少 saveUrl 参数！')
    }
  }
  // 失去焦点
  const onBlur = () => {
    console.log('失去焦点')
    if (props.focus) {
      if (props.delUrl && (data.value == null || data.value == '')) {
        onDelete()
      } else {
        onSave()
      }
    }
  }

  return {
    inputRef,
    getFormData,
    updateFormData,
    searchParent,
    isEdit,
    isDisabled,
    switchEdit,
    onSave,
    onDelete,
    onCancel,
    onInput,
    onBlur,
  }
}
